// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cSqg","list":"styles_list__2wZ8f","disableSelection":"styles_disableSelection__3jDzt"};